import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 滚动到顶部 hook：路由切换 / 锚点跳转时滚动到顶部
 */
export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

/**
 * 自定义事件：用于在点击卡片时主动触发滚动到顶部
 */
export function scrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
}